import { Guid } from "guid-typescript";
import { QuestionStatus } from './Enum/ModuleEnum';

export function updateModule(data: any, stateData: any) {
    switch (data.payload.field) {
        case 'moduleName':
            stateData.editModuleMetadata.module.name = data.payload.data;
            break;
        case 'moduleDescription':
            stateData.editModuleMetadata.module.description = data.payload.data;
            break;
        case 'moduleTypeId':
            stateData.editModuleMetadata.module.module_type_id = data.payload.data;
            break;
        case 'moduleCategoryId':
            stateData.editModuleMetadata.module.module_category_id = data.payload.data;
            break;
        case 'newPage':
            const reponseNewPage = addNewPage(stateData, data.payload.data);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = reponseNewPage;
            break;
        case 'pageTitle':
            const reponsePageTitle = addPageProperties(data.payload.data.pageNumber, stateData,
                'title', 'en', data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = reponsePageTitle;
            break;
        case 'pageDescription':
            const reponsePageDescription = addPageProperties(data.payload.data.pageNumber, stateData,
                'page_description', 'en', data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = reponsePageDescription;
            break;
        case 'summaryPage':
            const reponsePageSummary = addPageProperties(data.payload.data.pageNumber, stateData,
                'issummary', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = reponsePageSummary;
            break;

        // Cluster
        case 'addCluster':
            const reponseAddCluster = addClusterToPage(data.payload.data - 1, stateData);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = reponseAddCluster;
            break;
        case 'clusterName':
            const reponseClusterTitle = addClusterProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex, stateData
                , 'title', 'en', data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = reponseClusterTitle;

            break;
        case 'clusterDescription':
            const reponseClusterDescription = addClusterProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex, stateData
                , 'cluster_description', 'en', data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = reponseClusterDescription;
            break;
        case 'addQuestion':
            const reponseAddQuestion = addQuestionToPage(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                stateData);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = reponseAddQuestion;
            break;
        case 'questionClassTypeId':
            const updatedClassType = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'class_type', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = updatedClassType;
            break;
        case 'questionTypeId':
            const updatedInputType = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'input_type', undefined, data.payload.data.value);

            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = updatedInputType;
            break;
        case 'questionTooltip':
            const updatedTooltip = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'tooltip', 'en', data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = updatedTooltip;

            break;
        case 'questionTitle':
            const updatedTitle = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'title', 'en', data.payload.data.value, data.payload.data.isQuestionDirty, data.payload.data.selectedQuestionVersion, data.payload.data.question);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = updatedTitle;
            break;
        case 'questionNumber':
            const updatedResponse = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'question_number', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = updatedResponse;

            break;
        case 'showUnavailableCheckbox':
            const responseQuestion = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'show_unavailable_checkbox', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseQuestion;
            break;

        case 'showOtherTextbox':
            const responseShowOtherTextbox = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'show_other_textbox', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseShowOtherTextbox;
            break;

        case 'addQuestionOptions':
            const moduleQuestion = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'items', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = moduleQuestion;
            break;
        case 'copyQuestion':
            const copyQuestionObj = copyQuestion(data.payload.data.pageNumber, data.payload.data.clusterIndex, data.payload.data.questionIndex, stateData);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = copyQuestionObj;
            break;
        case 'validations':
            const responseValidations = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'validations', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseValidations;
            break;
        case 'visibleif':
            const responsevisibleIf = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'visibleIf', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responsevisibleIf;
            break;
        case 'limit':
            const responseLimit = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'limit', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseLimit;
            break;

        case 'isMandatory':
            const responseIsMandatory = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'ismandatory', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseIsMandatory;
            break;

        case 'defaultQuestionResponses':
            const responses = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'default_question_responses', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responses;
            break;

        case 'isAdminLevelAutoCalculate':
            const responseIsAdminLevelAutoCalculate = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'isAdminLevelAutoCalculate', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseIsAdminLevelAutoCalculate;
            break;
        case 'minValue':
            const responseMinValue = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'min_value', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseMinValue;
            break;
        case 'maxValue':
            const responseMaxValue = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'max_value', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseMaxValue;
            break;

        case 'classOneTitle':
            const responseClassOneTitle = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'question_one_title', 'en', data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseClassOneTitle;
            break;
        case 'classTwoTitle':
            const responseClassTwoTitle = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'question_two_title', 'en', data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseClassTwoTitle;
            break;
        case 'classThreeTitle':
            const responseClassThreeTitle = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'question_three_title', 'en', data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseClassThreeTitle;
            break;
        case 'horizontalConfig':
            console.log('horizontalConfig', data.payload.data.value);
            const responseHorizontalConfig = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'auto_calculation_config', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseHorizontalConfig;
            break;
        case 'verticalConfig':
            console.log('verticalConfig', data.payload.data.value);
            const responseVerticalConfig = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'auto_calculation_config', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseVerticalConfig;
            break;

        case 'pullQuestionFromRepo':
            const pulledQuestion = pullQuestionFromRepository(data.payload.data.pageNumber, data.payload.data.clusterIndex, data.payload.data.value, stateData);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = pulledQuestion;
            break;
        case 'deleteQuestion':
            const deleteQuestionObj = deleteQuestion(data.payload.data.pageNumber, data.payload.data.clusterIndex, data.payload.data.questionIndex, data.payload.data.value, stateData);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = deleteQuestionObj;
            break;

        case 'rearrange':
            const reArrangeQuestionObj = reArrangeQuestions(data.payload.data.pageNumber, data.payload.data.clusterIndex, stateData, data.payload.data.moveFromIndex,
                data.payload.data.moveToIndex);

            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = reArrangeQuestionObj;
            break;

        case 'isImpactOnGlobal':
            const responseisImpactOnGlobal = updateQuestionProperties(data.payload.data.pageNumber, data.payload.data.clusterIndex,
                data.payload.data.questionIndex, stateData, 'is_impact_on_global', undefined, data.payload.data.value);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = responseisImpactOnGlobal;
            break;
        case 'deleteCluster':
            const deleteClusterObj = deleteCluster(data.payload.data.pageNumber, data.payload.data.clusterIndex, stateData);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = deleteClusterObj;
            break;
        case 'deletePage':
            const deletePageObj = deletePage(data.payload.data.pageNumber, stateData);
            stateData.editModuleMetadata.moduleQuestion = null;
            stateData.editModuleMetadata.moduleQuestion = deletePageObj;
            break;
    }
    return stateData;
}

function reArrangeQuestions(pageNumber: any, clusterIndex: any, stateData: any, moveFromIndex: any, moveToIndex: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    const page = stateDataObj.pages.find((p: any) => p.page_number === pageNumber);
    page.isdirty = true;
    const filterCluster = page.question_clusters[clusterIndex];
    filterCluster.isdirty = true;
    const questions = filterCluster.questions;

    const movingItem = questions[moveFromIndex];
    questions.splice(moveFromIndex, 1);
    questions.splice(moveToIndex, 0, movingItem);

    console.log(stateData, 'ARRANGED');
    return stateDataObj;
}

function addClusterToPage(pageIndex: number, stateData: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    const emptyQuestionString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion.base_question_cluster);
    const emptyQuestionClusterObj = JSON.parse(emptyQuestionString);
    const page = stateDataObj.pages[pageIndex];
    page.isdirty = true;
    emptyQuestionClusterObj.isdirty = true;

    const question = emptyQuestionClusterObj.questions[0];
    const newQuestionId = Guid.create();
    question.question_id = newQuestionId.toString();

    page.question_clusters.push(emptyQuestionClusterObj);

    return stateDataObj;
}

function addNewPage(stateData: any, data: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    const pageString = JSON.stringify(data);
    const pageObj = JSON.parse(pageString);
    pageObj.isdirty = true;
    const cluster = pageObj.question_clusters[0];
    cluster.isdirty = true;
    const question = cluster.questions[0];
    question.isdirty = true;
    const newQuestionId = Guid.create();
    question.question_id = newQuestionId.toString();
    stateDataObj.pages.push(pageObj);
    return stateDataObj;
}

function addPageProperties(pageNumber: number, stateData: any, property: string,
    subProperty: any, value: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    const page = stateDataObj.pages.find((p: any) => p.page_number === pageNumber)
    page.isdirty = true;
    if (subProperty) {
        page[property][subProperty] = value;
    }
    else {
        page[property] = value;
    }


    return stateDataObj;
}

function addClusterProperties(pageNumber: number, clusterIndex: number, stateData: any, property: string
    , subProperty: string, value: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    const page = stateDataObj.pages.find((p: any) => p.page_number === pageNumber);
    page.isdirty = true;
    const clusterObj = page.question_clusters[clusterIndex];
    clusterObj.isdirty = true;
    clusterObj[property][subProperty] = value;

    return stateDataObj;
}

function addQuestionToPage(pageNumber: number, clusterIndex: number, stateData: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    const emptyQuestionString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion.base_question);
    const emptyQuestionObj = JSON.parse(emptyQuestionString);
    emptyQuestionObj.isdirty = true;
    const newQuestionId = Guid.create();
    emptyQuestionObj.question_id = newQuestionId.toString();
    const page = stateDataObj.pages.find((p: any) => p.page_number === pageNumber);
    page.isdirty = true;
    const filterCluster = page.question_clusters[clusterIndex];
    filterCluster.isdirty = true;
    filterCluster.questions.push(emptyQuestionObj);

    return stateDataObj;
}

function copyQuestion(pageNumber: number, clusterIndex: number,
    questionIndex: number, stateData: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    const page = stateDataObj.pages.find((p: any) => p.page_number === pageNumber);
    page.isdirty = true;
    const questionClusters = page.question_clusters[clusterIndex];
    questionClusters.isdirty = true;
    const questionToCopy = questionClusters.questions[questionIndex];
    const questionToCopyStr = JSON.stringify(questionToCopy);
    const copiedQuestion = JSON.parse(questionToCopyStr);
    copiedQuestion.isdirty = true;
    copiedQuestion.status = QuestionStatus.Draft
    const newQuestionId = Guid.create();
    copiedQuestion.question_id = newQuestionId.toString();
    copiedQuestion.question_number = '';
    stateDataObj.pages.find((p: any) => p.page_number === pageNumber)
        .question_clusters[clusterIndex].questions.push(copiedQuestion);

    return stateDataObj
}

function pullQuestionFromRepository(pageNumber: any, clusterIndex: any, data: any, stateData: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    const page = stateDataObj.pages.find((p: any) => p.page_number === pageNumber);
    page.isdirty = true;
    const questionClusters = page.question_clusters[clusterIndex];
    questionClusters.isdirty = true;
    data.status = QuestionStatus.Draft;
    questionClusters.questions.push(data);
    return stateDataObj;
}

function deleteQuestion(pageNumber: any, clusterIndex: any, questionIndex: any, value: any, stateData: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    const deletedQuestionIds = stateDataObj.deleted_question_ids && stateDataObj.deleted_question_ids.length > 0 ? [...stateDataObj.deleted_question_ids, value] : [value];
    stateDataObj.deleted_question_ids = deletedQuestionIds;
    const page = stateDataObj.pages.find((p: any) => p.page_number === pageNumber);
    if (page) {
        page.isdirty = true;
        const questionClusters = page.question_clusters[clusterIndex];
        if (questionClusters) {
            questionClusters.isdirty = true;
        }
        let questions = questionClusters.questions;
        questions = questions.filter((q: any, index: any) => index !== questionIndex);
        questionClusters.questions = questions;
    }
    return stateDataObj;
}

// delete the selected cluster
function deleteCluster(pageNumber: any, clusterIndex: any, stateData: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    stateDataObj.deleted_cluster_index = clusterIndex;
    const page = stateDataObj.pages.find((p: any) => p.page_number === pageNumber);
    if (page) {
        if (page.question_clusters.length > 0) {
            page.question_clusters.splice(clusterIndex, 1);
            stateDataObj.deleted_cluster_index = clusterIndex;
            stateDataObj.deleted_page_ids = null;
            stateDataObj.deleted_page_id=pageNumber;
        }
    }

    return stateDataObj;
}

// delete the selected page
function deletePage(pageNumber: any, stateData: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    if (stateDataObj.pages.length > 0) {
        const pageIndex = stateDataObj.pages.findIndex((p: any) => p.page_number === pageNumber);
        stateDataObj.pages.splice(pageIndex, 1);
        // stateDataObj.deleted_page_ids.push(pageIndex);
        stateDataObj.deleted_page_id=pageNumber;
        stateDataObj.deleted_cluster_index = null;
        if (stateDataObj.pages.length > 0) {
            stateDataObj.pages.forEach((pageItem: any, index: number) => {
                pageItem.page_number = index + 1;
            })
        }
    }
    
    return stateDataObj;
}

function updateQuestionProperties(pageNumber: number, clusterIndex: number,
    questionIndex: number, stateData: any, property: string, subProperty: any, value: any, isQuestionDirty?: boolean, version?: number, question?: any) {
    const stateDataString = JSON.stringify(stateData.editModuleMetadata.moduleQuestion);
    const stateDataObj = JSON.parse(stateDataString);
    const page = stateDataObj.pages.find((p: any) => p.page_number === pageNumber);
    page.isdirty = true;
    const filterQuestionCluster = page.question_clusters[clusterIndex];
    filterQuestionCluster.isdirty = true;
    const filterQuestion = filterQuestionCluster.questions[questionIndex];
    if (isQuestionDirty !== undefined && !isQuestionDirty) {
        filterQuestion.isdirty = false;
        filterQuestion.version = question.version;
        filterQuestion.items = question.items;
        filterQuestion.class_type = question.class_type;
        filterQuestion.class_type = question.class_type;
        filterQuestion.allow_digits = question.allow_digits;
        filterQuestion.input_type = question.input_type;
        filterQuestion.limit = question.limit;
        filterQuestion.max_value = question.max_value;
        filterQuestion.min_value = question.min_value;
        filterQuestion.question_comments = question.question_comments;
        filterQuestion.question_comments_count = question.question_comments_count;
        filterQuestion.question_one_title = question.question_one_title;
        filterQuestion.question_two_title = question.question_two_title;
        filterQuestion.question_three_title = question.question_three_title;
        filterQuestion.title = question.title;
        filterQuestion.tooltip = question.tooltip;
        filterQuestion.visibleIf = question.visibleIf;
        filterQuestion.validations = question.validations;
        filterQuestion.show_unavailable_checkbox = question.show_unavailable_checkbox;
        filterQuestion.show_other_textbox = question.show_other_textbox;
        filterQuestion.status = question.status;
        filterQuestion.ram_question_indicator_code = question.ram_question_indicator_code;
        filterQuestion.status = question.status;
        filterQuestion.auto_calculation_config = question.auto_calculation_config;
        filterQuestion.allow_digits = question.allow_digits;
        filterQuestion.is_visible = question.is_visible;
        filterQuestion.is_impact_on_global = question.is_impact_on_global;
        filterQuestion.ismandatory = question.ismandatory;
        filterQuestion.is_visible = question.is_visible;
    } else {
        filterQuestion.isdirty = true;
        if (filterQuestion.status === QuestionStatus.Approve) {
            filterQuestion.status = QuestionStatus.Modified
        }
    }

    if (subProperty) {
        filterQuestion[property][subProperty] = value;
    }
    else {
        filterQuestion[property] = value;
    }
    handleSpecialCase(property, value, filterQuestion);
    return stateDataObj;
}

function handleSpecialCase(property: any, data: any, question: any) {
    switch (property) {
        case 'limit':
            question.min_value = null;
            question.max_value = null;
            break;
        case 'input_type':
            if (data < 3 || data > 6) {
                // question.items = null;
            }
            break;
        case 'auto_calculation_config':
            question.auto_calculation_config.is_horizontal = question.auto_calculation_config.horizontal_config !== null;
            break;
    }
}

// validate only numeric inputs
export const handleKeyPress = (event: any) => {
    if (event.charCode !== 8 && event.charCode !== 0 && event.charCode !== 46 && event.charCode < 48 || event.charCode > 57) {
        event.preventDefault();
    }
}


// WEBPACK FOOTER //
// ./src/constants/commonFunctions.tsx